import React from 'react'
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { useTable, useExpanded } from 'react-table';
import { useMemo } from 'preact/hooks';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { AiFillCaretRight, AiFillCaretDown } from "react-icons/ai";
//style

import { getStudentsMarksByCourseOffering } from '../../Utils/apiServices';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
        marginTop:"20px",

    },
    tcell: {
        backgroundColor: "#fff",
        padding: 0,
        paddingBottom: "10px",
        paddingTop: "10px",
        paddingLeft:"10px",
        border: 0,
        fontSize: "11px",
        lineHeight: "150%",
        color: '#505F79',
        backgroundColor:'#dfe1e6',
    },
    tablehead: {
            borderBottom: "1px solid rgba(224, 224, 224, 1)",
            "&>:nth-child(1)": {
                "&>:nth-child(3)":{
                    // paddingLeft:"60px",
                    // paddingBottom:0,
                },
                "&>:nth-child(8)":{
                    // paddingLeft:"50px",
                    // paddingBottom:0,
                }
              }
    },

}));

export function Newtable({
    columns,
    data,
    renderComponents
}) {

    // const Columns = useMemo(() => columns, [])
    // const Data = useMemo(() => data, [])
    const classes = useStyles();

    const tableInstance = useTable({
        columns: columns,
        data: data
    }, useExpanded)
    const { getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        visibleColumns } = tableInstance
    return (
        <div>
            <TableContainer component={Paper} style={{padding:"10px"}}>
                <Table {...getTableProps()} >
                    <TableHead className={classes.tablehead}>
                        {
                            headerGroups.map((headerGroup) => (
                                <TableRow {...headerGroup.getHeaderGroupProps()}>
                                    {
                                        headerGroup.headers.map((column) => (
                                            <TableCell className={classes.tcell} {...column.getHeaderProps()}>{column.render('Header')}</TableCell>
                                        ))
                                    }
                                </TableRow>
                            ))
                        }

                    </TableHead>
                    <TableBody {...getTableBodyProps()}>
                        {
                            rows.map((row) => {
                                prepareRow(row)
                                return (
                                    <React.Fragment {...row.getRowProps()}>
                                        <TableRow >
                                            {
                                                row.cells.map((cell) => {
                                                    return (
                                                        <TableCell {...cell.getCellProps()} >
                                                            {cell.render('Cell')}
                                                        </TableCell>
                                                    )
                                                })
                                            }

                                        </TableRow>
                                        {row.isExpanded ? (
                                            <TableRow>
                                                <TableCell colSpan={visibleColumns.length}>
                                                    {/*
                                                        Inside it, call our renderRowSubComponent function. In reality,
                                                        you could pass whatever you want as props to
                                                        a component like this, including the entire
                                                        table instance. But for this example, we'll just
                                                        pass the row
                                                    */}
                                                    {renderComponents({ row })}
                                                </TableCell>
                                            </TableRow>
                                        ) : null}
                                    </React.Fragment>
                                )
                            })
                        }

                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}




function TabPanel(props) {


    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}




const defaultPropGetter = () => ({});

export default function Newcomponent() {

    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = React.useState(0);
    const [data, setData] = React.useState([])

    React.useEffect(res => {

        getStudentsMarksByCourseOffering().then(res => {
            setData(res)
        }).catch(err => {
            console.log("Err: ", err);
        })

    }, [])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const Columns = React.useMemo(
        () => [
            {
                // Make an expander cell
                Header: () => null, // No header
                id: 'expander', // It needs an ID
                Cell: ({ row }) => (
                    // Use Cell to render an expander for each row.
                    // We can use the getToggleRowExpandedProps prop-getter
                    // to build the expander.
                    <span {...row.getToggleRowExpandedProps()}>
                        {row.isExpanded ? <AiFillCaretDown /> : <AiFillCaretRight />}
                    </span>
                ),
            },
            {
                Header: 'Student',
                accessor: 'contactName',
            },
            {
                Header: 'Marks',
                columns: [
                    {
                        Header: 'Max',
                        accessor: 'maxMarks',
                    },
                    {
                        Header: 'Obtained',
                        accessor: 'marksObtained',
                    },
                ],
            },
            {
                Header: 'Percentage',
                accessor: 'percentage',
            },
            {
                Header: 'Grade',
                accessor: 'grade',
            },
            {
                Header: 'Penalty',
                accessor: 'penalty',
            },
            {
                Header: 'Final Grade',
                accessor: 'finalGrade',
            },
            {
                Header: 'Credits',
                columns: [
                    {
                        Header: 'Total',
                        accessor: 'credits',
                    },
                    {
                        Header: 'Earned',
                        accessor: 'creditsEarned',
                    }
                ]
            },
            {
                Header: 'Status',
                accessor: 'passStatus',
            },
        ], [])
    // const data = [
    //     {
    //         contactName: 'Pranav',
    //         maxMarks: 10,
    //         marksObtained: 9,
    //         marksInComponent: 4.5,
    //         scoreFinalized: 'Yes'
    //     },
    //     {

    //         contactName: 'Prashanth',
    //         maxMarks: 10,
    //         marksObtained: 9,
    //         marksInComponent: 4.5,
    //         scoreFinalized: 'No'
    //     }
    // ]

    const renderComponents= React.useCallback((({row})=>(
        <ComponentsMarksTable data={row.original}/>
      )),[])

    return (
        <div className={classes.root}>
            <AppBar position="static" color="default">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                >
                    <Tab label="Current" {...a11yProps(0)} />
                    <Tab label="History" {...a11yProps(1)} />
                </Tabs>
            </AppBar>
            <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={value}
                onChangeIndex={handleChangeIndex}
            >
                <TabPanel value={value} index={0} dir={theme.direction}>
                    <Newtable columns={Columns} data={data} renderComponents={renderComponents} />
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                    History
                </TabPanel>
            </SwipeableViews>
        </div>
    )
}


const ComponentsMarksTable = ({ data }) => {


    const columns = React.useMemo(
        () => [
            {
                // Make an expander cell
                Header: () => null, // No header
                id: 'expander', // It needs an ID
                Cell: ({ row }) => (
                    // Use Cell to render an expander for each row.
                    // We can use the getToggleRowExpandedProps prop-getter
                    // to build the expander.
                    <span {...row.getToggleRowExpandedProps()}>
                        {row.isExpanded ? <AiFillCaretDown /> : <AiFillCaretRight />}
                    </span>
                ),
            },
            {
                Header: 'Component',
                accessor: 'name',
            },
            {
                Header: 'Max Marks',
                accessor: 'maxMarks',
            },
            {
                Header: 'Marks Obtained',
                accessor: 'marksObtained',
            },
            {
                Header: 'Marks In course',
                accessor: 'marksInCourse',
            },
        ],
        []
    );

    const renderRowSubComponent = React.useCallback((({ row }) => (
        <SubComponentsMarksTable data={row.original} />
    )), [])

    return (
        <>
            {data?.components?.length &&
                <Newtable columns={columns} data={data?.components} renderComponents={renderRowSubComponent}>
                </Newtable>}
        </>
    )




}


function SubComponentsMarksTable({ data }) {


    const columns = React.useMemo(
        () => [

            {
                Header: 'Sub Component',
                accessor: 'name',
                // render:(({value,row})=>(<a href={`${routes.studentsMarksBySubComponent}/${row?.original?.id}`} target="_blank">{value}</a>))
            },
            {
                Header: 'Max Marks',
                accessor: 'maxMarks',
            },
            {
                Header: 'Marks Obtained',
                accessor: 'marksObtained',
            },
            {
                Header: "Component Marks",
                accessor: "marksInComponent"
            },
            {
                Header: 'Score Finalized',
                accessor: 'fianlized',
            },
        ],
        []
    );


    return (<>
        {data?.subComponents && <Newtable data={data?.subComponents} columns={columns} />}
    </>)
}


